/**
 * Persistent banner shown across every authenticated page when the
 * current session is the public demo. Sets read-only expectations
 * explicitly even though RBAC's viewer role already blocks every
 * mutation server-side. Banner CTA points prospects at the partner
 * sales contact (Doable is invite-only per W4-P3, so /signup is a
 * dead-end without a token).
 */
import { useAuthStore } from '../lib/auth-store'
import { navigate } from '../lib/router'
import { Button, ButtonLink } from './ui/button'

const SALES_EMAIL = 'hello@doable.app'

export function DemoBanner() {
  const clear = useAuthStore((s) => s.clear)

  function exitDemo() {
    clear()
    navigate('/')
  }

  return (
    <div className="sticky top-0 z-40 flex flex-wrap items-center justify-between gap-3 border-b border-border bg-volt-soft px-4 py-2 text-sm text-volt-ink">
      <span>
        <strong className="font-semibold">Demo mode</strong>
        <span className="mx-2 text-volt-ink/50">·</span>
        Read-only. Click around to see what Doable looks like for a real
        team — your changes won't save.
      </span>
      <span className="flex items-center gap-2">
        <ButtonLink href={`mailto:${SALES_EMAIL}?subject=Doable%20invite%20request`} size="sm" className="font-semibold">
          Request your invite
        </ButtonLink>
        <Button type="button" variant="ghost" size="sm" onClick={exitDemo} className="text-volt-ink hover:bg-volt/10 hover:text-volt-ink">
          Exit demo
        </Button>
      </span>
    </div>
  )
}
